export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/seller_page_perseus/Education.9b53994.svg";